import React, { useEffect } from 'react';
import { enableAnimations } from 'config/helpers';
import { ContactBanner } from 'views/contact/subcomponents';
import {
  Banner,
  Specializations,
  Benefits,
  Projects,
  OurCompetitiveAdvantages,
  Reviews,
  TransformationInPractise,
} from './subcomponents';
import './renewableEnergyIndustry.scss';

const RenewableEnergyIndustry = () => {
  useEffect(() => {
    enableAnimations();
  }, []);

  return (
    <div className={'single-page single-page--hero renewable-energy-industry'}>
      <Banner />
      <Specializations />
      <Benefits />
      <Projects />
      <OurCompetitiveAdvantages />
      <Reviews />
      <TransformationInPractise />
      <ContactBanner
        dataPdWebforms={
          'https://webforms.pipedrive.com/f/cs9dOxJOmE5gaVtA984VfwEuPoJdBsZgEEtvPiKgr6U3hcEK0dU8ApHM9rhP1RzZtx'
        }
      />
    </div>
  );
};

export default RenewableEnergyIndustry;
